import React from 'react';

const columns = [
  { key: 'ticket_key', label: 'Ticket', sortable: true },
  { key: 'terminated_user', label: 'Employee', sortable: true },
  { key: 'processing_time', label: 'Processing Time', sortable: true },
  { key: 'support_user', label: 'Approved By', sortable: true },
  { key: 'lit_hold', label: 'Lit Hold', sortable: false },
  { key: 'actions', label: 'Actions', sortable: false },
];

function TerminationTable({ terminations, onEdit, onRemove, actionLoading, sortField, sortDir, onSort }) {
  const formatTime = (isoString) => {
    if (!isoString) return 'N/A';
    try {
      let dateStr = isoString;
      if (!dateStr.endsWith('Z') && !dateStr.includes('+') && !dateStr.includes('-', 10)) {
        dateStr = dateStr + 'Z';
      }
      const date = new Date(dateStr);
      return date.toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        timeZoneName: 'short',
      });
    } catch {
      return isoString;
    }
  };

  const getJiraUrl = (ticketKey) => {
    return `https://instacart.atlassian.net/browse/${ticketKey}`;
  };

  return (
    <div className="table-container">
      <table className="termination-table">
        <thead>
          <tr>
            {columns.map((col) => (
              <th
                key={col.key}
                className={col.sortable ? 'sortable' : ''}
                onClick={col.sortable ? () => onSort(col.key) : undefined}
                aria-sort={
                  sortField === col.key
                    ? sortDir === 'asc' ? 'ascending' : 'descending'
                    : undefined
                }
              >
                {col.label}
                {sortField === col.key && (
                  <span className="sort-indicator" aria-hidden="true">
                    {sortDir === 'asc' ? '\u2191' : '\u2193'}
                  </span>
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {terminations.map((term) => (
            <tr key={term.ticket_key} className={term.lit_hold ? 'lit-hold' : ''}>
              <td data-label="Ticket">
                <a
                  href={getJiraUrl(term.ticket_key)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ticket-link"
                >
                  {term.ticket_key}
                </a>
              </td>
              <td data-label="Employee">{term.terminated_user}</td>
              <td data-label="Processing Time">{formatTime(term.processing_time)}</td>
              <td data-label="Approved By">{term.support_user}</td>
              <td data-label="Lit Hold">
                <span className={`lit-hold-badge ${term.lit_hold ? 'yes' : 'no'}`}>
                  {term.lit_hold ? 'Yes' : 'No'}
                </span>
              </td>
              <td data-label="Actions" className="actions-cell">
                <button
                  onClick={() => onEdit(term)}
                  className="action-button edit"
                  disabled={actionLoading === term.ticket_key}
                  aria-label={`Edit processing time for ${term.ticket_key}`}
                >
                  Edit Time
                </button>
                <button
                  onClick={() => onRemove(term.ticket_key)}
                  className="action-button remove"
                  disabled={actionLoading === term.ticket_key}
                  aria-label={`Remove ${term.ticket_key} from queue`}
                >
                  {actionLoading === term.ticket_key ? 'Removing...' : 'Remove'}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default TerminationTable;
